(function(){
  function initScope(scope){
    (scope||document).querySelectorAll('.product-template .js-form-add-to-card').forEach(function(form){
      if(form.dataset.ftcSideChoiceReady==='1')return;
      var swatches=[].slice.call(form.querySelectorAll('.js-swatch-item'));
      if(!swatches.length)return;
      form.dataset.ftcSideChoiceReady='1';

      swatches.forEach(function(item){
        item.classList.add('ftc-required-side-choice');
        item.dataset.ftcChoiceConfirmed='0';
        var title=item.querySelector('.swatch-title');
        var optionName=title?title.textContent.trim():'OPTION';
        item.dataset.ftcOptionName=optionName;

        if(title&&!title.querySelector('.ftc-side-choice-title-icon')){
          var icon=document.createElement('span');
          icon.className='ftc-side-choice-title-icon';
          icon.setAttribute('aria-hidden','true');
          icon.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="m7 10 5 5 5-5"/><path d="M5 21h14"/></svg>';
          title.insertBefore(icon,title.firstChild);
        }

        var wrapper=item.querySelector('.select-wrapper');
        var select=item.querySelector('select.js-option-item');
        var help=item.querySelector('[data-ftc-side-help]');
        if(!help){
          help=document.createElement('div');
          help.className='ftc-side-choice-help';
          help.setAttribute('data-ftc-side-help','');
          help.textContent='Choisissez '+optionName+' avant de continuer.';
          if(wrapper)wrapper.insertAdjacentElement('afterend',help);
        }

        if(select){
          var fixing=false;
          function ensurePlaceholder(){
            if(fixing)return;
            fixing=true;
            var placeholder=select.querySelector('option[data-ftc-side-placeholder]');
            if(!placeholder){
              placeholder=document.createElement('option');
              placeholder.value='';
              placeholder.disabled=true;
              placeholder.setAttribute('data-ftc-side-placeholder','');
              placeholder.textContent='Choisir '+optionName;
              select.insertBefore(placeholder,select.firstChild);
            }
            if(item.dataset.ftcChoiceConfirmed!=='1'){
              placeholder.selected=true;
              select.value='';
            }
            fixing=false;
          }
          ensurePlaceholder();

          var observer=new MutationObserver(function(){
            ensurePlaceholder();
          });
          observer.observe(select,{childList:true});

          select.addEventListener('change',function(){
            if(!select.value){unconfirmChoice(item);return;}
            confirmChoice(item);
          });
        }else{
          item.querySelectorAll('.js-option-item').forEach(function(input){
            input.addEventListener('change',function(){confirmChoice(item);});
          });
        }
      });

      function confirmChoice(item){
        item.dataset.ftcChoiceConfirmed='1';
        item.classList.remove('ftc-choice-error');
        item.classList.add('ftc-choice-confirmed');
        var h=item.querySelector('[data-ftc-side-help]');
        if(h)h.textContent='Sélectionné : '+getChoice(item);
        unlockIfReady();
      }
      function unconfirmChoice(item){
        item.dataset.ftcChoiceConfirmed='0';
        item.classList.remove('ftc-choice-confirmed');
        var h=item.querySelector('[data-ftc-side-help]');
        if(h)h.textContent='Choisissez '+(item.dataset.ftcOptionName||'OPTION')+' avant de continuer.';
        lockPurchase();
      }
      function getChoice(item){
        var s=item.querySelector('select.js-option-item');
        if(s)return s.value;
        var c=item.querySelector('.js-option-item:checked');
        return c?c.value:'';
      }
      function pending(){
        return swatches.find(function(item){return item.dataset.ftcChoiceConfirmed!=='1'||!getChoice(item);});
      }
      function showRequired(item){
        item.classList.add('ftc-choice-error');
        var h=item.querySelector('[data-ftc-side-help]');
        if(h)h.textContent='Veuillez choisir '+(item.dataset.ftcOptionName||'OPTION')+' avant de continuer.';
        item.scrollIntoView({behavior:'smooth',block:'center'});
        var control=item.querySelector('select.js-option-item,.js-option-item');
        setTimeout(function(){if(control&&control.focus)control.focus();},200);
      }
      function blockPurchase(e){
        var p=pending();
        if(!p)return true;
        if(e){e.preventDefault();e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();}
        showRequired(p);
        return false;
      }
      form.addEventListener('submit',function(e){blockPurchase(e);},true);
      var add=form.querySelector('.js-btn-add-to-cart');
      if(add)add.addEventListener('click',function(e){if(pending())blockPurchase(e);},true);
      var dynamic=form.querySelector('.dynamic-checkout');
      function ensureOverlay(){
        if(!dynamic)return;
        if(dynamic.querySelector('.ftc-side-choice-lock-overlay'))return;
        dynamic.classList.add('ftc-side-choice-locked');
        var overlay=document.createElement('div');
        overlay.className='ftc-side-choice-lock-overlay';
        overlay.setAttribute('role','button');
        overlay.setAttribute('aria-label','Choisir les options avant achat');
        overlay.addEventListener('click',function(e){blockPurchase(e);},true);
        dynamic.appendChild(overlay);
      }
      function lockPurchase(){ensureOverlay();}
      function unlockIfReady(){
        if(pending()){ensureOverlay();return;}
        if(dynamic){
          dynamic.classList.remove('ftc-side-choice-locked');
          var o=dynamic.querySelector('.ftc-side-choice-lock-overlay');
          if(o)o.remove();
        }
      }
      ensureOverlay();
    });
  }

  function boot(){initScope(document);}
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }
  document.addEventListener('shopify:section:load',function(e){initScope(e.target||document);});
})();
